<script setup lang="ts">
import {
    DropdownMenuRoot,
    type DropdownMenuRootEmits,
    type DropdownMenuRootProps,
    useEmitAsProps,
    useForwardPropsEmits,
} from 'reka-ui'

const props = defineProps<DropdownMenuRootProps>()
const emits = defineEmits<DropdownMenuRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
    <DropdownMenuRoot v-bind="forwarded">
        <slot />
    </DropdownMenuRoot>
</template>
